import { getFileContentType } from "./file-content-type";

const HEIC_TYPES = new Set(["image/heic", "image/heif"]);

export function isHeicFile(file: File): boolean {
	return HEIC_TYPES.has(getFileContentType(file).toLowerCase());
}

export async function heicPreviewUrl(file: File, maxEdge = 320): Promise<string | null> {
	try {
		const { default: decode } = await import("heic-decode");
		const { width, height, data } = await decode({
			buffer: new Uint8Array(await file.arrayBuffer())
		});
		const full = document.createElement("canvas");
		full.width = width;
		full.height = height;
		full.getContext("2d")?.putImageData(
			new ImageData(new Uint8ClampedArray(data), width, height),
			0,
			0
		);
		const scale = Math.min(1, maxEdge / Math.max(width, height));
		const preview = document.createElement("canvas");
		preview.width = Math.max(1, Math.round(width * scale));
		preview.height = Math.max(1, Math.round(height * scale));
		preview.getContext("2d")?.drawImage(full, 0, 0, preview.width, preview.height);
		const blob = await new Promise<Blob | null>((resolve) =>
			preview.toBlob(resolve, "image/jpeg", 0.85)
		);
		return blob ? URL.createObjectURL(blob) : null;
	} catch {
		return null;
	}
}
